import { html, slotted } from '@microsoft/fast-element';
/**
 * The Grid Pro Cell Template.
 * @public
 */
export const CellTemplate = html `
  <template>
    <slot ${slotted('slottedRenderer')} @slotchange="${(x) => x.slottedAgRendererChanged()}"></slot>
  </template>
`;
